import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../firebase/config';
import { onAuthStateChanged } from 'firebase/auth';
import { API_URL } from '../config';

// Add this line temporarily for debugging
console.log('API_URL:', API_URL);

const AuthContext = createContext();

export function useAuth() {
    return useContext(AuthContext);
}

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [userProfile, setUserProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchUserProfile = async (user) => {
            try {
                const token = await user.getIdToken();
                const response = await fetch(`${API_URL}/users/${user.uid}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });

                if (response.ok) {
                    const contentType = response.headers.get('content-type');
                    if (contentType && contentType.includes('application/json')) {
                        const profile = await response.json();
                        setUserProfile(profile);
                        setError(null);
                    } else {
                        throw new Error('Received non-JSON response from server');
                    }
                } else {
                    // Handle specific HTTP error codes
                    if (response.status === 404) {
                        setUserProfile(null);
                        setError('User profile not found');
                    } else {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                }
            } catch (error) {
                console.error('Error fetching user profile:', error);
                setError(error.message);
                setUserProfile(null);
            }
        };

        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            setUser(user);
            if (user) {
                await fetchUserProfile(user);
            } else {
                setUserProfile(null);
                setError(null);
            }
            setLoading(false);
        });

        return unsubscribe;
    }, []);

    const value = {
        user,
        userProfile,
        loading,
        error
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
} 